import React from 'react'
import { useProject } from '../../../../../model/hooks/useProject'
import { Button } from '../../../../../components/ui/button'
import { Link } from 'react-router-dom'
import { RoutesEnum } from '../../../../../model/enums/RoutesEnum'
import { Field } from 'formik'
import { NumberInput } from '../../../../../components/inputs/NumberInput'
import { SquareArrowOutUpRightIcon } from 'lucide-react'

interface Props {}

export const AccompanyingReportBuildingParametersView: React.FC<Props> = (props) => {
  const { id: projectId } = useProject()

  return (
    <div className="flex flex-col gap-6 p-4 rounded-md bg-gray-50  border-gray-300 border border-dashed">
      <span className="uppercase text-sm text-gray-500 font-bold">Údaje z průvodní zprávy</span>
      <div className="grid grid-cols-3 gap-3 text-right">
        <Field
          name="readonly.a3.builtUpArea"
          component={NumberInput}
          trailing={
            <>
              m<sup>2</sup>
            </>
          }
          label="Zastavěná plocha"
          disabled
        />
        <Field
          name="readonly.a3.floorArea"
          component={NumberInput}
          trailing={
            <>
              m<sup>2</sup>
            </>
          }
          label="Podlahová plocha"
          disabled
        />
        <Field
          name="readonly.a3.enclosedSpace"
          component={NumberInput}
          trailing={
            <>
              m<sup>3</sup>
            </>
          }
          label="Obestavěný prostor"
          disabled
        />
      </div>
      <div className="grid grid-cols-3 gap-3 text-right">
        <Field
          name="readonly.a4.numberOfPeople"
          label="Předpokládaný počet osob na stavbě"
          disabled
          component={NumberInput}
          trailing={<>os.</>}
        />
      </div>
      <div className="flex justify-end">
        <Link
          to={`${RoutesEnum.PROJECTS}/${projectId}/${RoutesEnum.ACCOMPANYING_REPORT}#a3Heading`}
          target="_blank"
        >
          <Button type="button" variant="secondary">
            Upravit
            <SquareArrowOutUpRightIcon className="text-gray-700 w-4 ml-1" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
